import React, {FunctionComponent} from "react";
import {makeStyles} from "tss-react/mui";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import {useHistory, useLocation} from "react-router-dom";
import {ListItemButton, Menu, MenuItem, Theme} from "@mui/material";
import {useAppDispatch, useAppSelector} from "@/Redux/Redux";
import _ from "lodash";
import {selectViewerRights, ViewerState,} from "@/Redux/Auth/AuthReducer";
import {DRAWER_WIDTH} from "@/Components/Sidebar/Constants";
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import {RequestPage} from "@mui/icons-material";
import {useTranslation} from "@/Utils/CustomHooks/useTranslation";
import {useSelector} from "react-redux";

interface MenuProcessesProps {
}

const useStyles = makeStyles()((theme: Theme) => ({
    listItem: {
        color: "#fff",
    },
    listItemIcon: {
        color: "#fff !important",
    },
    active: {
        backgroundColor: "#e42022!important",
        borderColor: "#e42022!important",
        fontWeight: 600,
    }
}));

const MenuProcessesData: FunctionComponent<MenuProcessesProps> = (): JSX.Element => {
    const {classes, cx} = useStyles();
    const dispatch = useAppDispatch();
    const history = useHistory();

    const location = useLocation();
    const {t} = useTranslation();

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const rights = useSelector((state) =>
        selectViewerRights(state as ViewerState),
    );
    const {modules} =
        useAppSelector((state) => state.app);

    const isActive = (pathname: string, exact: boolean = false) => {
        if (exact) {
            return location.pathname === pathname;
        }
        return _.includes(location.pathname, pathname);
        //return pathname === location.pathname;
    };
    return (
        <>
            <ListItemButton
                dense
                key={"customers"}
                className={cx(
                    classes.listItem,
                    isActive("/manager/bookings", true) ||
                    isActive("/manager/contract/") ||
                    isActive("/manager/reservation/") ||
                    isActive("/manager/transfer/") ||
                    isActive("/manager/transfer-reservation/") ||
                    isActive("/manager/accounting-book") ||
                    isActive("/manager/offers") ||
                    isActive("/manager/offer") ||
                    isActive("/manager/invoices") ||
                    isActive("/manager/invoice")
                        ? classes.active
                        : ""
                )}
                onClick={handleClick}
            >
                <ListItemIcon className={classes.listItemIcon}>
                    <RequestPage/>
                </ListItemIcon>
                <ListItemText primary={t('sidebar.processes')}/>
                <ChevronRightIcon/>
            </ListItemButton>
            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                }}
                sx={{
                    '& .MuiPaper-root': {
                        width: DRAWER_WIDTH
                    }
                }}
            >
                <MenuItem onClick={() => {
                    history.push("/manager/bookings", {from: "sidebar"});
                    handleClose()
                }}>{t("sidebar.bookings")}</MenuItem>
                <MenuItem onClick={() => {
                    history.push("/manager/invoices");
                    handleClose()
                }}>{t("sidebar.invoice-search")}</MenuItem>
                {<MenuItem
                    disabled={
                        rights.findIndex(
                            (e) => e.right === "VERKAUF",
                        ) === -1
                    }
                    onClick={() => {
                        history.push("/manager/offers");
                        handleClose()
                    }}>{t('sidebar.Offer')}
                </MenuItem>}
                <MenuItem
                    onClick={() => {
                        history.push("/manager/accounting-book");
                        handleClose()
                    }}
                >
                    {t("sidebar.accountingBook")}
                </MenuItem>
            </Menu>
        </>
    );
};

export default MenuProcessesData;
